import * as React from "react";

const ENFlag = (props) => (
	<svg viewBox="0 0 25 16" {...props}>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#bf0a30",
			}}
			d="M0 184h379v16H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="M0 168h379v16H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#bf0a30",
			}}
			d="M0 152h379v16H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="M0 136h379v16H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#bf0a30",
			}}
			d="M0 121h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="M0 106h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#bf0a30",
			}}
			d="M0 91h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="M0 76h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#bf0a30",
			}}
			d="M0 61h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="M0 46h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#bf0a30",
			}}
			d="M0 31h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="M0 16h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#bf0a30",
			}}
			d="M0 1h379v15H0z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#002868",
			}}
			transform="matrix(.07848 0 0 .07948 .044 -.04)"
			d="M0 1h152v105H0z"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -6.726 -6.113)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -4.764 -6.113)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -2.723 -6.113)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -.761 -6.113)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 1.2 -6.113)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 3.24 -6.113)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -5.705 -6.907)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -6.726 -7.782)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -5.705 -8.576)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -6.726 -9.45)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -5.705 -10.246)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -6.726 -11.12)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -5.705 -11.915)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -6.726 -12.789)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -3.744 -6.907)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -4.764 -7.782)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -3.744 -8.576)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -4.764 -9.45)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -3.744 -10.246)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -4.764 -11.12)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -3.744 -11.915)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -4.764 -12.789)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -1.782 -6.907)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -2.723 -7.782)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 1.2 -7.782)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -.761 -7.782)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 2.22 -6.907)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 .259 -6.907)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -2.723 -12.789)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -1.782 -11.915)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -2.723 -11.12)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -1.782 -10.246)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -2.723 -9.45)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -1.782 -8.576)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 3.24 -7.782)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -.761 -9.45)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -.761 -12.789)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 -.761 -11.12)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 2.22 -8.576)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 .259 -8.576)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 .259 -11.915)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 .259 -10.246)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 3.24 -9.45)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 1.2 -9.45)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 1.2 -12.789)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 1.2 -11.12)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 3.24 -12.789)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 2.22 -11.915)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 3.24 -11.12)"
		/>
		<path
			style={{
				fillRule: "evenodd",
				fill: "#fff",
			}}
			d="m100.33 146.67 4.139-.772 1.275-4.013 2.014 3.698 4.21-.028-2.895 3.058 1.327 3.996-3.802-1.808-3.39 2.497.544-4.175z"
			transform="matrix(.0823 .00715 -.00674 .08725 2.22 -10.246)"
		/>
		<path
			style={{
				fill: "#fff",
			}}
			d="M-.45 200.45 380.58 1.84l-.89 199.06z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fill: "#00247d",
			}}
			d="m220.56 200.2-.32-72.639 158.65.159.225 72.32zM379.01 1.395 250.05 69.693h128.73zM0 200.22l141.54-73.69 19.771.225-.45 73.69z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fill: "#fff",
			}}
			d="m379.85 180.2-.41 19.538-33.128 2.06-130.02-68.203 1.483-9.515 57.668 1.573zM380.13.497 246.68 71.49l41.339.898 91.439-48.528zM-.45 199.55l148.59-76.35 15.233.58.054 14.498-116.63 61.72z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				fill: "#cf142b",
			}}
			d="m-.674 199.78 146.56-75.53 15.425.055-.45 7.847-129.42 67.85zm238.824-74.37 28.757.899 112.33 60.21-.45 13.03zm140.82-8.75-218.89-.225 72.581-37.175 146.34.29z"
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			d="m209.21 199.54.45-107.53-37.86 19.142.076 88.803z"
			style={{
				fill: "#cf142b",
			}}
			transform="matrix(.06557 0 0 .07948 .044 -.04)"
		/>
		<path
			style={{
				stroke: "#fff",
				fill: "none",
			}}
			transform="matrix(.06574 0 0 .07948 .044 -.04)"
			d="M0 1h379v199H0z"
		/>
	</svg>
);

export default ENFlag;
